import AboutUs from './AboutUs'
import Blog from './Blog'
import BlogDetail from './BlogDetail'
import Contact01 from './Contact01'
import Home02 from './Home02'
import ServiceDetailWrapper from './ServiceDetail'
import Services from './Services'
import TeamMemberDetailWrapper from './TeamMemberDetail'

const routes = [
    {
        path: '/',
        component: Home02,
        seo: {
            title: 'Stats Elite | Data Consulting, MERL and Analytics Training',
            description: 'Stats Elite helps organizations turn data into evidence-based decisions through MERL, statistics, analytics consulting, research support, and professional training.',
            pageKey: 'home'
        }
    },
    {
        path: '/about-v1',
        component: AboutUs,
        seo: {
            title: 'About Stats Elite | MERL, Statistics and Data Consulting Experts',
            description: 'Meet the Stats Elite team supporting organizations with monitoring, evaluation, research, learning, statistics, data analytics, and evidence-based strategy.',
            pageKey: 'about'
        }
    },
    {
        path: '/services-v1',
        component: Services,
        seo: {
            title: 'Services | MERL, Statistics, Analytics and Training | Stats Elite',
            description: 'Explore Stats Elite services in MERL, statistics, data analytics, data governance, research support, impact evaluation, dashboards, and professional training.',
            pageKey: 'services'
        }
    },
    { path: '/services/:slug', component: ServiceDetailWrapper },
    {
        path: '/blog',
        component: Blog,
        seo: {
            title: 'Resources | Data, MERL and Analytics Insights | Stats Elite',
            description: 'Read Stats Elite resources on data consulting, MERL, statistics, analytics, research, evaluation, dashboards, and evidence-based decision making.',
            pageKey: 'blog'
        }
    },
    { path: '/blog/:slug', component: BlogDetail },
    {
        path: '/contact-v1',
        component: Contact01,
        seo: {
            title: 'Contact Stats Elite | Data Consulting and MERL Support',
            description: 'Contact Stats Elite in Dar es Salaam for MERL consulting, statistics training, data analytics, dashboards, research support, and evaluation services.',
            pageKey: 'contact'
        }
    },
    { path: '/team/:id', component: TeamMemberDetailWrapper }
]

export default routes;
